import { ActionIcon, Button, Group, TextInput } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { Search, X } from 'tabler-icons-react';
import './search-button.styles.css';

interface Props {
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  setDontUseEffect?: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
  disabled?: boolean;
  search: string;
}
function SearchButton(props: Props) {
  const { setSearch, setPage, setDontUseEffect, className, disabled, search } =
    props;

  const searchRef = React.createRef<HTMLButtonElement>();
  const [value, setValue] = useState('');

  const handleSearch = (e: any) => {
    e.preventDefault();

    if (setDontUseEffect !== undefined && setPage !== undefined) {
      setDontUseEffect(true);
      setPage(1);
      setDontUseEffect(false);
      setSearch(e.target.elements.search.value);
    } else if (setPage !== undefined) {
      setPage(1);
      setSearch(e.target.elements.search.value);
    } else {
      setSearch(e.target.elements.search.value);
    }
  };

  useEffect(() => {
    setValue(search);

    // return ()  => {
    //   setSearch(value)
    // }
  }, []);

  return (
    <>
      <form onSubmit={handleSearch}>
        <Group spacing='xs'>
          <TextInput
            placeholder='Search...'
            icon={<Search strokeWidth={2} size={18} />}
            name='search'
            data-cy='searchField'
            type='search'
            value={value}
            onChange={(value) => {
              setValue(value.currentTarget.value);
            }}
            rightSection={
              <ActionIcon
                onClick={() => {
                  setSearch('');
                  //TODO REMOVE THIS
                  if (!searchRef.current) {
                    return;
                  }
                  setValue('');
                  return searchRef.current.click;
                }}
              >
                <X color='#adb5bd' strokeWidth={2} size={18} />
              </ActionIcon>
            }
          />
          <Button
            type='submit'
            data-cy='searchButton'
            ref={searchRef}
            className={className}
            disabled={disabled !== undefined ? disabled : false}
          >
            SEARCH
          </Button>
        </Group>
      </form>
    </>
  );
}

export default SearchButton;
